import { create, test, enforce } from 'vest';

// @ts-ignore
import isEmail from 'validator/lib/isEmail';

enforce.extend({ isEmail });

const validators = create((data = {}) => {
  test('person', 'Contact person can\'t be empty.', () => {
    enforce(data.person).isNotEmpty();
  });
  test('email', 'Email invalid.', () => {
    enforce(data.email).isEmail();
  });
  test('email', 'Email can\'t be empty.', () => {
    enforce(data.email).isNotEmpty();
  });
  test('phone', 'Phone can\'t be empty.', () => {
    enforce(data.phone).isNotEmpty();
  });
  test('country', 'Country can\'t be empty.', () => {
    enforce(data.country).isNotEmpty();
  });
});

export default validators;
